import { ChildWithParents } from '@/types/Child'

export function isChildInSection(child: ChildWithParents, daycareId: number, sectionId: number | undefined): boolean {
    return child.daycares.some(
        (daycare) =>
            daycare.daycareId === daycareId &&
            daycare.visible &&
            daycare.sections.some((section) => section.sectionId === sectionId)
    )
}
